import { lazyLoad } from 'utils/loadable';

export const CouponDiscounts = lazyLoad(() => import('./index'));
export const CouponUsageHistory = lazyLoad(() => import('./UsageHistory'));
